import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { api, DUCK_LOGO, formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { CheckCircle2, XCircle } from "lucide-react";

export default function Verify() {
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);
  const token = params.get("token");
  const [state, setState] = useState({ loading: true, ok: false, msg: "" });

  useEffect(() => {
    if (!token) { setState({ loading: false, ok: false, msg: "Missing token" }); return; }
    api.post("/auth/verify-email", { token })
      .then(({ data }) => setState({ loading: false, ok: true, msg: data.message }))
      .catch((e) => setState({ loading: false, ok: false, msg: formatApiError(e.response?.data?.detail) || "Verification failed" }));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="w-full max-w-md p-10 rounded-2xl text-center cq-in" data-testid="verify-card">
        <img src={DUCK_LOGO} alt="" className="h-14 w-14 mx-auto object-contain" />
        {state.loading && <p className="mt-6 text-slate-500">Verifying…</p>}
        {!state.loading && state.ok && <>
          <CheckCircle2 className="mx-auto text-green-500 mt-4" size={54} />
          <h1 className="font-display text-3xl font-black mt-3" data-testid="verify-success">Email verified 🎉</h1>
          <p className="text-slate-600 mt-2">{state.msg}</p>
          <Link to="/login" className="mt-6 inline-block bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-xl font-bold" data-testid="verify-signin">Sign in</Link>
        </>}
        {!state.loading && !state.ok && <>
          <XCircle className="mx-auto text-red-500 mt-4" size={54} />
          <h1 className="font-display text-3xl font-black mt-3" data-testid="verify-error">Verification failed</h1>
          <p className="text-slate-600 mt-2">{state.msg}</p>
          <Link to="/login" className="mt-6 inline-block text-amber-600 font-bold">Back to sign in</Link>
        </>}
      </Card>
    </div>
  );
}
